<template>
  <div class="tw-flex tw-font-new tw-gap-2">
    <a href="/">Home /</a>
    <div class="" v-if="nomeLeilao && nomeLote">
      <router-link :to="`/leilao/index/leilao_id/${leilaoId}`">{{ titulo }}</router-link>
    </div>
    <div class="" v-if="leilaoId && nomeLote == null">{{ titulo }}</div>
    <div class="" v-if="loteId">lote {{ nomeLote }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      categoria: this.$route.params.categoria || null,
      leilaoId: this.$route.params.id || null,
      loteId: this.$route.params.idlote || null,
    };
  },
  props: ["categorialeilao", "nomeLeilao", "nomeLote"],
  computed: {
    titulo() {

      if ( this.nomeLeilao )
        return this.nomeLeilao.split('|')[0]

      return ''
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/BreadCrumb.vue